<template>
  <div class="alterTel">
    <div class="telDiv">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <el-form-item label="原手机号码" prop="oldphone">
          <el-input
            v-model.number="form.oldphone"
            placeholder="请输入旧手机号码"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="新手机号码" prop="phone">
          <el-input
            v-model.number="form.phone"
            placeholder="请输入新手机号码"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认手机号码" prop="confirmTel">
          <el-input
            v-model.number="form.confirmTel"
            placeholder="请再次输入新手机号码"
            maxlength="11"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="alter">
      <button class="alterBtn" @click="updateTel">确认修改</button>
    </div>
    <!-- <div class="copyright">技术 • 运营</div>
    <div class="copyrightCompany">辽宁校友汇数据科技有限公司</div> -->
  </div>
</template>
<script>
import Base64 from "@/utils/base64";

export default {
  data() {
    var ckeckConfirm = (rule, value, callback) => {
      if (value !== this.form.phone) {
        callback(new Error("两次输入手机号不一致!"));
      } else {
        callback();
      }
    };
    return {
      mine: "",
      bottomCheck: "mine",
      form: {
        oldphone: "",
        phone: "",
        confirmTel: "",
      },
      rules: {
        oldphone: [
          { required: true, message: "请输入旧手机号码", trigger: "blur" },
          {
            type: "number",
            message: "手机号格式不正确",
            trigger: "blur",
            transform(value) {
              var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
              if (!phonereg.test(value)) {
                return false;
              } else {
                return Number(value);
              }
            },
          },
        ],
        phone: [
          { required: true, message: "请输入新手机号码", trigger: "blur" },
          {
            type: "number",
            message: "手机号格式不正确",
            trigger: "blur",
            transform(value) {
              var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
              if (!phonereg.test(value)) {
                return false;
              } else {
                return Number(value);
              }
            },
          },
        ],
        confirmTel: [
          { required: true, message: "请再次输入新手机号码", trigger: "blur" },
          {
            type: "number",
            message: "手机号格式不正确",
            trigger: "blur",
            transform(value) {
              var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
              if (!phonereg.test(value)) {
                return false;
              } else {
                return Number(value);
              }
            },
          },
          { validator: ckeckConfirm, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    const phone = localStorage.getItem("phone");
    if (phone) {
      this.form.oldphone = phone;
    }
  },
  methods: {
    updateTel() {
      this.$refs.form.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        console.log(this.form);
        let base64 = new Base64()
        const userid = base64.encode(window.localStorage.getItem("user_id"))
        const result = await this.$http({
          url: "/settings/updatePhone",
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.$qs.stringify({
            userId: userid,
            oldPhone: this.form.oldphone,
            newPhone: this.form.phone,
          }),
        });
        if (result.data.msg !== "成功修改") {
          this.$toast(result.data.msg);
        } else {
          this.$toast("修改成功");
          window.history.back(-1);
        }
      });
    },
    gotoIndex() {
      return this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scoped>
.alterTel {
  display: flex;
  flex-direction: column;
  align-items: center;
  .telDiv {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    width: 90%;
    background-color: white;
    border-radius: 15px;
    .el-form {
      width: 94%;
      /deep/.el-input__inner {
        background-color: #f5f5f5;
      }
      /deep/ .el-form-item__label {
        padding: 0;
      }
    }
  }
  .alter {
    position: absolute;
    top: 80%;
    left: 5%;
    width: 90%;
    .alterBtn {
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      border-radius: 30px;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
  .copyright {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 400;
    color: #999999;
  }
  .copyrightCompany {
    position: absolute;
    top: 93%;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 400;
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/AlterTel.vue